
import makerjs from "makerjs";
function C28(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param,R = Param[2].param,
    // T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       w = W * 1 * myZoom,       
       h = H * 1 * myZoom,       
       r = R * 1 * myZoom,       
      
       //hd=r-l,
      //  hd=Math.sqrt(s1*s1-(b/2*b/2)), hh=h-s1+hd,
      //  x0 = 0, x1 = 0, x2 = b, x3 = b, y0 = 0, y1 = hh, y2 = hh, y3 = 0,
       /**假设长半轴为ry 短半轴为 rx 焦点离顶点距离为t
        * rx=r,  c=ry-t a=ry  b=rx=r  c*c=a*a-b*b
        * 求 ry=a=(t*t-r*r)/2*t  
       * */
      // aa=r*r/(2*r),
      rx=w/2,ry=h/2,
       glassH =h, glassW = w;
       if (w !== 0) {
        var TxtW ="W="+ W;
    }  if (R !== 0) {
     var TxtR = "R="+R;
   }    if (h !== 0) {
    var TxtH = "H="+H;
  }
  // console.log("rx,ry,h,w,aa=====",rx,ry,h,w,aa);
  // var myEgGapAEllipse=new makerjs.models.Ellipse(rx, ry);
  var drawAbnormalShapeC28=new makerjs.models.Ellipse(rx, ry);
  //  var drawAbnormalShapeC28 = {
  //      paths: {
        
  //       "EllipseArc": makerjs.models.Ellipse(2*t, 2*r),
  //      }
  //  };
   var drawAbnormalShapeC28MarkW = {
       paths: {
        "bottomLine": new makerjs.paths.Line([-w/2, 0-h/2-markShift], [w/2, 0-h/2-markShift]),        
        "RightShortUpline": new makerjs.paths.Line([-w/2, 0-h/2], [-w/2, 0-h/2-2*markShift]),
        "RightShortDnline": new makerjs.paths.Line([w/2, 0-h/2], [w/2, 0-h/2-2*markShift]),
       }  
   };
   var drawAbnormalShapeC28MarkH = {
       paths: {
        "RightLine": new makerjs.paths.Line([-w/2-markShift, 0-h/2], [-w/2-markShift, h/2]),                
        "RightShortUpline": new makerjs.paths.Line([-w/2-2*markShift, h/2], [-w/2, h/2]),
        "RightShortDnline": new makerjs.paths.Line([-w/2-2*markShift, 0-h/2], [-w/2, 0-h/2]),
       }
   };
   var drawAbnormalShapeC28MarkR = {
       paths: {
        "LeftLine": new makerjs.paths.Line([w/2-r, 0], [w/2, 0]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeC28MarkW, TxtW,  [-w/2, 0-h/2-3*markShift], [w/2, 0-h/2-3*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC28MarkH, TxtH,  [-w/2-3*markShift, 0-h/2], [-w/2-3*markShift, h/2]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC28MarkR, TxtR,[w/2-r-6*markShift, 0], [w/2-r, 0]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeC28: drawAbnormalShapeC28,
      }
    };
  markers={
      models: {
        drawAbnormalShapeC28: drawAbnormalShapeC28,
        drawAbnormalShapeC28MarkW:drawAbnormalShapeC28MarkW,
        drawAbnormalShapeC28MarkR:drawAbnormalShapeC28MarkR,
        drawAbnormalShapeC28MarkH:drawAbnormalShapeC28MarkH,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C28;